import React, { useState } from "react";
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { motion, AnimatePresence } from "framer-motion";

const navItems = ["home", "about", "work", "skills", "testimonials"];

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed top-4 left-0 w-full z-50 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto bg-white/5 border border-white/10 backdrop-blur-xl rounded-full px-5 sm:px-8 py-3 shadow-glow flex items-center justify-between">
        <a href="#home" className="flex items-center gap-3">
          <span className="inline-flex h-10 w-10 rounded-2xl bg-gradient-to-br from-primary via-accent to-primaryDark shadow-glow" />
          <div className="flex flex-col leading-tight">
            <span className="text-sm uppercase tracking-[0.2em] text-slate-300">Portfolio</span>
            <span className="text-lg font-semibold text-white">Nishan Neupane</span>
          </div>
        </a>

        <ul className="hidden md:flex items-center gap-6 text-sm font-medium text-slate-200">
          {navItems.map((item) => (
            <li key={item}>
              <a
                href={`#${item}`}
                className="capitalize px-3 py-2 rounded-full hover:text-white hover:bg-white/10 transition-colors duration-200"
              >
                {item}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#work"
            className="px-4 py-2 rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors"
          >
            Projects
          </a>
          <a
            href="#footer"
            className="px-4 py-2 rounded-full bg-gradient-to-r from-primary via-accent to-primaryDark text-white shadow-glow"
          >
            Let&apos;s talk
          </a>
        </div>

        <button
          className="md:hidden p-2 rounded-xl bg-white/10 text-white"
          onClick={() => setIsMenuOpen(true)}
          aria-label="Open menu"
        >
          <HiMenuAlt4 className="text-2xl" />
        </button>
      </div>

      <AnimatePresence>
        {isMenuOpen && (
          <motion.aside
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.28, ease: "easeInOut" }}
            className="fixed top-0 right-0 w-full sm:w-80 h-screen bg-[#02060d]/90 backdrop-blur-xl border-l border-white/10 shadow-glow z-50 flex flex-col p-6 gap-8"
          >
            <button
              onClick={() => setIsMenuOpen(false)}
              className="self-end p-2 rounded-lg bg-white/5 text-white"
              aria-label="Close menu"
            >
              <HiX className="text-3xl" />
            </button>

            <nav className="flex flex-col gap-5 mt-4">
              {navItems.map((item) => (
                <a
                  key={item}
                  href={`#${item}`}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-xl capitalize text-slate-100 px-3 py-2 rounded-lg hover:bg-white/10"
                >
                  {item}
                </a>
              ))}
              <a
                href="#footer"
                onClick={() => setIsMenuOpen(false)}
                className="mt-2 inline-flex items-center justify-center px-4 py-3 rounded-xl bg-gradient-to-r from-primary via-accent to-primaryDark text-white font-semibold shadow-glow"
              >
                Let&apos;s talk
              </a>
            </nav>
          </motion.aside>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
